import React from 'react';
import { 
  Box, 
  Typography, 
  Button,
  Paper,
  IconButton
} from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 8,
  right: 8,
  padding: 4,
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.05)',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.1)',
  },
  zIndex: 10 // Ensure button is above other elements
}));

const EnhanceToolOptions = ({ settings, onChange, onApply }) => {
  // Set default values when component loads
  React.useEffect(() => {
    onChange({
      resolution: '8k',
      sharpness: 75,
      noiseReduction: 75
    });
  }, [onChange]);

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 3, 
        borderRadius: 2,
        background: theme => theme.palette.mode === 'dark' ? 'rgba(30, 30, 40, 0.9)' : 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
        position: 'relative' // Added for absolute positioning of close button
      }}
    >
      <CloseButton onClick={() => onApply(false)}>
        <CloseIcon fontSize="small" />
      </CloseButton>
      
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, textAlign: 'center' }}>
        <AutoFixHighIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
        Görsel İyileştirme
      </Typography>
      
      <Typography variant="body2" sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
        Yapay zeka ile görselinizi otomatik olarak iyileştirin. Daha net, daha keskin ve daha yüksek kaliteli bir sonuç elde edin.
      </Typography>
      
      
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button 
          variant="contained" 
          color="primary" 
          size="large"
          onClick={() => onApply(true)}
          startIcon={<AutoFixHighIcon />}
          sx={{ 
            px: 4, 
            py: 1.5, 
            borderRadius: 2,
            fontWeight: 600,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4
            }
          }}
        >
          İyileştirmeyi Başlat (10 Kredi)
        </Button>
      </Box>
    </Paper>
  );
};

export default EnhanceToolOptions;
